import React from 'react';
import { Box, Typography } from '@mui/material';
import HelpTip from './HelpTip';

interface Props {
  label: string;
  value: string;
  help?: React.ReactNode;
  footnote?: string;
}

const MetricCard: React.FC<Props> = ({ label, value, help, footnote }) => (
  <Box
    data-testid="metric-card"
    sx={{
      p: 2,
      bgcolor: 'background.paper',
      color: 'text.primary',
      borderRadius: 1,
      border: '1px solid',
      borderColor: 'divider',
      height: '100%',
    }}
  >
    <Box sx={{ display: 'flex', alignItems: 'center', mb: 0.5 }}>
      <Typography variant="caption" color="text.secondary">
        {label}
      </Typography>
      {help && <HelpTip label={`About ${label}`}>{help}</HelpTip>}
    </Box>
    <Typography variant="h6" color="text.primary" sx={{ fontWeight: 700 }}>
      {value}
    </Typography>
    {footnote && (
      <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 0.5 }}>
        {footnote}
      </Typography>
    )}
  </Box>
);

export default MetricCard;
